import { RouteObject } from "react-router-dom";
import { PageNotFound } from "../app/404";
import { LandingPage } from "../app/_website";
import { FindEventsPage } from "../app/_website/find-events";
import { PricingPage } from "../app/_website/pricing";
import { ErrorPage } from "../app/error";
import { PreviewSingleEvent } from "../app/events/preview";
import { LegalPage } from "../app/legal";
import { Layout } from "../components/layout/layout";

export const websiteRouter: RouteObject[] = [
  {
    path: "/",
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        path: "",
        element: (
          <Layout navShadowOnPageScroll={false}>
            {({ navbarHeight, pageScrollProgress }) => (
              <>
                <div className="absolute inset-0 z-[0] flex items-end">
                  <img
                    alt="gradient"
                    src="/assets/images/gradientBg.png"
                    className="sticky bottom-0 h-[50vh] w-full object-cover md:h-fit"
                  />
                </div>

                <FindEventsPage
                  navbarHeight={navbarHeight}
                  pageScrollProgress={pageScrollProgress}
                />
              </>
            )}
          </Layout>
        ),
      },
      {
        path: "for-organizers",

        element: (
          <Layout>
            {({ isSignedIn }) => <LandingPage isSignedIn={isSignedIn} />}
          </Layout>
        ),
      },
      {
        path: "pricing",
        element: <Layout>{() => <PricingPage />}</Layout>,
      },
      {
        path: "legal/:doc",
        element: (
          <Layout footerClassName="mt-10">
            {() => <LegalPage className="max-width-website" />}
          </Layout>
        ),
      },
      {
        path: "404",
        element: (
          <Layout>
            {() => (
              <div className="max-width-website flex items-center pt-20">
                <PageNotFound />
              </div>
            )}
          </Layout>
        ),
      },
      {
        path: ":slug",
        element: (
          <Layout>
            {() => (
              <div className="max-width-website py-10">
                <PreviewSingleEvent canBuy doHoldTicket={false} />
              </div>
            )}
          </Layout>
        ),
      },
      {
        path: ":slug/:source",
        element: (
          <Layout>
            {() => (
              <div className="max-width-website py-10">
                <PreviewSingleEvent canBuy doHoldTicket={false} />
              </div>
            )}
          </Layout>
        ),
      },
      {
        path: ":slug/:source/:tikketPurchaseSessionId",
        element: (
          <Layout>
            {() => (
              <div className="max-width-website py-10">
                <PreviewSingleEvent canBuy doHoldTicket={false} />
              </div>
            )}
          </Layout>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <Layout>
        {() => (
          <div className="max-width-website flex items-center">
            <PageNotFound />
          </div>
        )}
      </Layout>
    ),
  },
];
